// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__YdBAO","feedback":"footer_feedback__l3LGh","pulseColor":"footer_pulseColor__a2k6f"};